import React from "react";
import { motion } from "framer-motion";
import { Key, Wallet, Tv, Backpack, ShoppingBag, Luggage } from "lucide-react";

const items = [
  { icon: Key, label: "Keys" },
  { icon: Wallet, label: "Wallet" },
  { icon: Tv, label: "TV remote" },
  { icon: Backpack, label: "Backpack" },
  { icon: ShoppingBag, label: "Purse" },
  { icon: Luggage, label: "Luggage" },
];

const Problem = () => {
  return (
    <section
      id="problem"
      data-testid="problem-section"
      className="relative py-28 md:py-36 bg-[#FAFAFA] overflow-hidden"
    >
      <div className="mx-auto max-w-7xl px-6">
        <div className="grid lg:grid-cols-12 gap-16 items-start">
          <div className="lg:col-span-5">
            <p className="text-xs tracking-[0.22em] uppercase text-zinc-500 font-medium">The Problem</p>
            <h2 className="mt-3 font-display text-4xl md:text-5xl lg:text-[56px] font-semibold tracking-[-0.02em] leading-[1.02]">
              Your things don't talk back. <span className="italic font-light text-zinc-500">Yet.</span>
            </h2>
            <p className="mt-7 text-zinc-600 text-lg leading-relaxed">
              Keys vanish. Wallets hide. Remotes disappear into cushions.
            </p>
            <p className="mt-4 text-zinc-600 text-lg leading-relaxed">
              Stop searching. Start calling.
            </p>
          </div>

          <div className="lg:col-span-7 grid grid-cols-2 md:grid-cols-3 gap-4">
            {items.map((it, i) => (
              <motion.div
                key={it.label}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, amount: 0.3 }}
                transition={{ duration: 0.5, delay: i * 0.05 }}
                data-testid={`problem-item-${i}`}
                className="group relative aspect-square rounded-2xl bg-white border border-zinc-200/80 p-5 flex flex-col justify-between overflow-hidden hover:border-zinc-300 transition"
              >
                <div className="absolute -right-8 -top-8 w-24 h-24 glow-silver blur-xl opacity-0 group-hover:opacity-100 transition duration-500" />
                <it.icon className="w-7 h-7 text-zinc-700" strokeWidth={1.5} />
                <div>
                  <div className="text-[10px] tracking-widest uppercase text-zinc-400 mb-1">Often lost</div>
                  <div className="font-display text-xl tracking-tight">{it.label}</div>
                </div>
              </motion.div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Problem;
